/**
 * Chapter019.js — Hazardous Substances / Dangerous Goods Policy (OHSE 019)
 * Migrated from SWMS Platform Chapter019.tsx → JavaScript
 *
 * Static policy text only — company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

const CONSIDERATION_ITEMS = [
  'Flammability and exclusivity',
  'Toxicity (short and long term)',
  'Carcinogenic classification if relevant',
  'Chemical action and instability',
  'Corrosive properties',
  'Safe use and engineering controls',
  'Environmental hazards',
  'Storage requirements',
];

export default function Chapter019({ companyName }) {
  const cn = companyName || '[Company Name]';
  const Co = () => <span className="font-semibold text-[#c9a84c]">{cn}</span>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 019</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">
          Hazardous Substances / Dangerous Goods
        </h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">
            Hazardous Substances Policy
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Company policy and procedures for handling hazardous substances and dangerous goods
          </p>
        </div>
        <div className="p-6 space-y-4 text-sm text-[#1a1a2e] leading-relaxed">
          <p>
            <Co /> provides a current (within 5 years of the date of issue) MSDS to the principal
            Contractor for all products and substances to be used for the work activity.
          </p>

          <p>
            Before a product or substance is used for the work activity, <Co /> reviews the Material
            Safety Data Sheet (MSDS) to determine if the product or substance is classified as hazardous.
          </p>

          <p>
            All employees involved in the use of products classified as hazardous, are provided with
            information and training to allow safe completion of the required task.
          </p>

          <p>
            As a minimum standard, all safety and environmental precautions for use listed on the MSDS
            are followed when using the substance and are included in the Safe Work Method Statement.
          </p>

          <p>
            No products or substances, including chemicals or fibrous materials, are brought to the
            workplace without a current MSDS.
          </p>

          <p>All products and substances to be brought to the workplace are documented.</p>

          <div>
            <p>
              <Co /> considers the following when selecting chemicals and substances for use on site:
            </p>
            <ul className="mt-2 ml-1 space-y-1.5">
              {CONSIDERATION_ITEMS.map((item, idx) => (
                <li key={idx} className="flex items-start gap-2.5">
                  <span className="mt-2 w-1 h-1 rounded-full bg-[#c9a84c] shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <p>
            All storage and use of hazardous substances and dangerous goods is in accordance with the
            MSDS and legislative requirements.
          </p>

          <p>
            All hazardous substances and dangerous goods are stored in their original containers with
            the label intact at all times.
          </p>

          <p>
            Hazardous substances and dangerous goods of any quantity are not stored in amenities,
            containers (unless properly constructed for the purpose), sheds or offices.
          </p>
        </div>
      </div>
    </div>
  );
}
